module.exports = __webpack_public_path__ + "media/images/emblems/Obergoms_(1)-060fc9e5178989cde5e7c5f71f2e79ab.png";